export const LOGIN_SUCCESS = 'views/auth/LOGIN_SUCCESS';
export const LOGIN_FAILED = 'views/auth/LOGIN_FAILED';
export const USER_LOADED = 'views/auth/USER_LOADED';
export const AUTH_ERROR = 'views/auth/AUTH_ERROR';
export const LOGOUT = 'views/auth/LOGOUT';
export const REGISTER_SUCCESS = 'views/auth/REGISTER_SUCCESS';
export const REGISTER_FAILED = 'views/auth/REGISTER_FAIL';

// New constants for Microsoft SSO
export const MICROSOFT_LOGIN_SUCCESS = 'MICROSOFT_LOGIN_SUCCESS';
export const MICROSOFT_LOGIN_FAILED = 'MICROSOFT_LOGIN_FAILED';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_INIT_COMPLETE = 'AUTH_INIT_COMPLETE';

// New constants for Enterprise SSO (PingFederate, Okta, Auth0, etc.)
export const ENTERPRISE_SSO_LOGIN_SUCCESS = 'ENTERPRISE_SSO_LOGIN_SUCCESS';
export const ENTERPRISE_SSO_LOGIN_FAILED = 'ENTERPRISE_SSO_LOGIN_FAILED';

// Token expiration handling
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';

// Clear auth error
export const CLEAR_AUTH_ERROR = 'CLEAR_AUTH_ERROR';
